import { render, staticRenderFns } from "./salesDeliveryOrder.vue?vue&type=template&id=72325957&"
import script from "./salesDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./salesDeliveryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports